module.exports = __webpack_public_path__ + "img/t3-gold.f5ee8a0c.png";